import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as Cancel } from '../../../../assets/icons/close.svg'
import { ReactComponent as Save } from '../../../../assets/icons/save.svg'
import { IRegex, useLookupStore } from '../../../../stores/lookUpStore'

import styles from './edit-regex.module.scss'
interface IEditRegexProps {
    regex: IRegex
    setIsEditing: React.Dispatch<React.SetStateAction<boolean>>
}

function EditRegex(props: IEditRegexProps) {
    const { regex, setIsEditing } = props
    const { _id, name, pattern } = regex

    const [, { editRegex }] = useLookupStore()

    const { t } = useTranslation()

    const [newName, setNewName] = useState(name)
    const [newPattern, setNewPattern] = useState(pattern)

    const handleSave = (e?: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault()

        if (!newName && !newPattern) return

        editRegex({ _id, name: newName, pattern: newPattern })
        setIsEditing(false)
    }

    const handleCancelChanges = () => {
        setNewName(name)
        setNewPattern(pattern)
        setIsEditing(false)
    }

    return (
        <form className={styles.editRegex} onSubmit={(e) => handleSave(e)}>
            <div className={styles.editRegex__data}>
                <div className={styles.editRegex__nameSection}>
                    <input
                        className={styles.editRegex__input}
                        type="text"
                        value={newName}
                        onChange={(e) => setNewName(e.target.value)}
                    />
                </div>
                <div className={styles.editRegex__patternSection}>
                    <input
                        className={styles.editRegex__input}
                        type="text"
                        value={newPattern}
                        onChange={(e) => setNewPattern(e.target.value)}
                    />
                    <div className={styles.editRegex__buttons}>
                        <button
                            className={styles.editRegex__btn}
                            onClick={() => handleSave()}
                        >
                            <Save
                                className={styles.editRegex__icon}
                                alt={t('save')}
                            />
                        </button>
                        <button
                            className={styles.editRegex__btn}
                            onClick={handleCancelChanges}
                        >
                            <Cancel
                                className={styles.editRegex__icon}
                                alt={t('cancel')}
                            />
                        </button>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default EditRegex
